export default __webpack_public_path__ + "static/media/graphic_black_cd.9865480f.jpg";